import React, { Component } from "react";
import "../style/loginStyle.css";
import logo from "../img/sadat logo-png.png";
import * as yup from 'yup';
import {Link} from "react-router-dom";
import axios from "axios";
import {AiOutlineMail, AiOutlineUser} from "react-icons/ai";
import { API_BASE_URL } from '../api/client';

class Login extends Component {

    state = {
        account:{
            user:'',
            email:''
        },
        errors: [],
        loading: false,
    };

    render() {
        const {user,email} = this.state.account
        return (
            <div className="container-login">
                <div className="login-bg" aria-hidden="true">
                    <div className="login-bg-photo"/>
                    <div className="login-bg-shade"/>
                </div>
                <div className="login-shell">
                    <div className="login-brand">
                        <img className="brand-mark" src={logo} alt="لوگوی سعادت پرتال"/>
                        <h1>سعادت پرتال</h1>
                        <div className="brand-line" aria-hidden="true"/>
                        <p>بازیابی دسترسی حساب سازمانی — لینک یا دستورالعمل به ایمیل ثبت‌شده ارسال می‌شود.</p>
                    </div>
                    <div className="login-panel">
                        <form className="login-form" onSubmit={this.handleSubmit}>
                            <div className="title-form">
                                <h3>فراموشی رمز</h3>
                            </div>
                            <p className="form-hint">نام کاربری و ایمیل حساب را وارد کنید</p>

                            <div className="form-group">
                                <label className="field-label" htmlFor="forgot-user">نام کاربری</label>
                                <div className="field-wrap">
                                    <span className="field-icon"><AiOutlineUser size={18}/></span>
                                    <input
                                        id="forgot-user"
                                        type="text"
                                        name="user"
                                        value={user}
                                        onChange={this.handleChange}
                                        className={`form-control input${this.state.errors.includes('لطفا نام کاربری را وارد کنید') ? ' is-invalid' : ''}`}
                                        placeholder="نام کاربری"
                                        autoComplete="username"
                                    />
                                </div>
                                {this.state.errors.includes('لطفا نام کاربری را وارد کنید') ? (
                                    <span className="field-error">لطفا نام کاربری را وارد کنید</span>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label className="field-label" htmlFor="forgot-email">ایمیل</label>
                                <div className="field-wrap">
                                    <span className="field-icon"><AiOutlineMail size={18}/></span>
                                    <input
                                        id="forgot-email"
                                        type="email"
                                        name="email"
                                        value={email}
                                        onChange={this.handleChange}
                                        className={`form-control input${this.state.errors.includes('ایمیل معتبر نیست') ? ' is-invalid' : ''}`}
                                        placeholder="name@example.com"
                                        autoComplete="email"
                                    />
                                </div>
                                {this.state.errors.includes('ایمیل معتبر نیست') ? (
                                    <span className="field-error">ایمیل معتبر نیست</span>
                                ) : null}
                                {this.state.errors.includes('شما امکان دسترسی به سیستم ندارید') ? (
                                    <span className="field-error">شما امکان دسترسی به سیستم ندارید</span>
                                ) : null}
                                {this.state.errors.includes('ایمیل صحیح نمی باشد') ? (
                                    <span className="field-error">ایمیل صحیح نمی باشد</span>
                                ) : null}
                            </div>
                            <button type="submit" className="btn-login" disabled={this.state.loading}>
                                {this.state.loading ? 'در حال ارسال…' : 'ارسال لینک بازیابی'}
                            </button>
                            <Link to="/" className="btn-login btn-secondary-login d-flex align-items-center justify-content-center">
                                بازگشت به ورود
                            </Link>
                        </form>
                    </div>
                </div>
            </div>
        );
    }

    handleChange = ({currentTarget: input}) => {
        const account = {...this.state.account};
        account[input.name] = input.value;
        this.setState({account})
    }
    schema = yup.object().shape({
        user: yup.string().required('لطفا نام کاربری را وارد کنید'),
        email: yup.string().email('ایمیل معتبر نیست').required('ایمیل معتبر نیست')
    })

    validate = async () => {
        try {
            const result = await this.schema.validate(this.state.account, {abortEarly: false});
            this.setState({errors: []});
            return result;
        } catch (error) {
            this.setState({errors: error.errors})
        }
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({loading: true});
        const getValue = await this.validate();
        if (!getValue) {
            this.setState({loading: false});
            return;
        }

        try {
            await axios.post(`${API_BASE_URL}/api/v1/email/forgot/password`, {
                username: this.state.account.user,
                email: this.state.account.email
            }, {
                params: {
                    username: getValue.user,
                },
                headers: {
                    "content-type": "application/x-www-form-urlencoded",
                }
            });
            this.setState({loading: false, errors: []});
            window.location = '/';
        } catch (err) {
            const status = err?.response?.status;
            if (status === 403) {
                this.setState({errors: ['ایمیل صحیح نمی باشد'], loading: false});
            } else if (status === 500) {
                this.setState({errors: ['شما امکان دسترسی به سیستم ندارید'], loading: false});
            } else {
                this.setState({errors: ['شما امکان دسترسی به سیستم ندارید'], loading: false});
            }
        }
    }
}

export default Login;
